var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollab7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 113,
    viewBox: "0 0 410 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 74,
    width: 100,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 74.1909H99.7361V112.267H0V74.1909Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7712 93.5703C46.2569 93.5703 42.9911 92.8336 40.3254 91.4396L11.6214 76.4323L3.02022 81.601C-1.06819 84.0569 -0.996779 87.8221 3.17953 90.006L42.8798 110.764C44.808 111.772 47.2731 112.268 49.7712 112.268C52.6882 112.268 55.6477 111.592 57.8506 110.27L96.7159 86.9132C100.804 84.456 100.733 80.6908 96.5566 78.5082L88.3028 74.1909L60.6892 90.7864C57.7009 92.5808 53.8239 93.5703 49.7712 93.5703Z",
    fill: "url(#paint0_linear_130_378)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8121 53.6567L89.9204 50L73.872 59.7854L71.1167 61.4649L68.3628 63.1445L60.8501 67.7257C57.8538 69.5541 53.9653 70.5593 49.9033 70.5593C46.3796 70.5593 43.1052 69.8099 40.4325 68.3931L31.8252 63.8258L28.9763 62.3158L26.1273 60.8045L10.2675 52.3886L3.02887 56.803C-1.07034 59.3029 -1.00011 63.132 3.18722 65.3538L11.4641 69.7445L14.313 71.2559L17.1606 72.7672L42.9937 86.472C44.9256 87.4967 47.3986 88 49.9033 88C52.8265 88 55.7953 87.3146 58.0025 85.9687L82.8387 70.8249L85.594 69.1453L88.3479 67.4657L96.9718 62.2074C101.071 59.7089 100.999 55.8785 96.8121 53.6567Z",
    fill: "url(#paint1_linear_130_378)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8121 31.2525L57.0056 10.5028C55.0737 9.49456 52.6021 9 50.096 9C47.1728 9 44.204 9.6749 41.9968 10.9974L3.02887 34.3455C-1.07034 36.8005 -1.00011 40.563 3.18722 42.7462L10.0789 46.3393L12.9278 47.8243L15.7767 49.3093L31.6365 57.5775L34.4855 59.0612L37.3344 60.5476L42.9937 63.4986C44.9256 64.5054 47.3986 65 49.9033 65C52.8265 65 55.7953 64.3251 58.0025 63.0026L62.6649 60.2088L65.4202 58.5584L68.1741 56.9081L84.2226 47.2929L86.9779 45.6425L89.7318 43.9921L96.9718 39.6545C101.071 37.1995 100.999 33.4356 96.8121 31.2525Z",
    fill: "url(#paint2_linear_130_378)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_130_378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 0,
    width: 58,
    height: 109
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.693 0.77832H185.626V108.692H128.693V0.77832Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_130_378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.166 17.4941C164.939 17.2878 160.534 21.3152 160.326 26.4921C160.326 26.51 160.324 26.5251 160.324 26.543V35.5932H181.41V50.9107H160.324V108.692H141.344V50.9107H128.693V35.5932H141.344V25.1391C141.344 10.5201 153.997 0.783708 168.054 0.783708C174.493 0.647583 180.754 2.88058 185.626 7.04958L178.598 20.2757C176.068 18.6573 173.167 17.6976 170.163 17.49",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260 35V108.3H245.446L242.67 99.9249H240.6C237.827 103.415 231.591 109 219.113 109C199.705 109 190 95.0372 190 74.7913V35H210.109V69.9036C210.109 78.9786 210.8 91.5448 223.28 91.5448C229.519 91.5448 239.917 88.0537 239.917 69.2087V35H260Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.204 49.7192C294.881 49.7192 292.073 52.5227 292.073 56.0295C292.073 60.9373 298.396 62.3383 303.311 63.738C316.656 66.5428 330 70.7473 330 86.1657C330 101.585 317.358 110 301.905 110C285.047 110 271.703 99.4853 271 84.0641H289.26C289.951 90.3937 295.54 95.0399 301.902 94.5775C309.627 94.5775 311.033 90.373 311.033 87.5695C311.033 81.9612 306.116 80.5588 300.497 79.1577C292.068 77.0631 273.103 73.5494 273.103 56.7272C273.1 42.0094 287.157 35 301.204 35C318.062 35 328.598 44.8142 329.298 57.4277H311.038C311.038 53.9237 308.941 49.7192 301.204 49.7192Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.733 77.055H356.122C358.202 88.1654 367.261 92.3334 375.616 92.3334C380.994 92.5926 386.171 90.2693 389.541 86.0822H408.34C403.192 100.008 389.802 109.19 374.921 108.997C354.474 108.939 337.943 92.3608 338 71.9668C338.002 71.58 338.009 71.1946 338.022 70.8065C337.342 51.1695 352.752 34.6993 372.442 34.0204C373.036 34 373.631 33.9957 374.227 34.0039C393.026 34.0039 412.519 47.199 409.733 77.0577V77.055ZM357.515 62.4733H390.24C388.779 55.2922 382.259 50.2657 374.921 50.6689C367.092 50.1573 359.916 55.0234 357.515 62.4733Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_378",
    x1: 49.868,
    y1: 12.3204,
    x2: 49.868,
    y2: 112.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_130_378",
    x1: 50,
    y1: 12.3984,
    x2: 50,
    y2: 109.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1FFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF16D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_130_378",
    x1: 50,
    y1: 9,
    x2: 50,
    y2: 110.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FB8C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab7);
export default __webpack_public_path__ + "static/media/collab-7.14372da644c5e389576a8121c7b757b7.svg";
export { ForwardRef as ReactComponent };